import {Component, Input} from '@angular/core';
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";

@Component({
  selector: 'app-message-delivery-dropshipping-confirm',
  templateUrl: './message-delivery-dropshipping-confirm.component.html',
  styleUrls: ['./message-delivery-dropshipping-confirm.component.scss']
})
export class MessageDeliveryDropshippingConfirmComponent {
  // Нова схема дропшипу (картка #867): наклейку і реєстр клієнт уже завантажив у формі
  @Input() newScheme = false;

  public data: OrdersSuccessData;

  public isDeliveryDropshippingConfirmation: boolean = false;

  deliveryDropshippingConfirmationShow(data: OrdersSuccessData) {
    this.data = data;
    this.isDeliveryDropshippingConfirmation = true;
  }

    protected readonly parseFloat = parseFloat;
}
